import React, { useCallback } from "react";
import ModalWrapper from "../../modal-wrapper/modal-wrapper";
import { ConfirmUsernameModalsProps } from "./modal-confirm-username-type";
import { ContentBodyStyled, ContentButtonsStyled, TextInfoSuccessStyled, TitleSuccessStyled } from "./style-component";
import CustomButton from "@/components/custom-button/custom-button";
import SocialMediaCard from "@/components/social-media-card/social-media-card";
import TextNoteWithProcess from "../../text-node-with-process/text-node-with-process";

const ModalConfirmUsername: React.FC<ConfirmUsernameModalsProps> = ({
  open = false,
  setOpen,
  loading,
  success,
  onConfirm,
  onCancel,
  onContinue,
  url,
  socialMediaName,
  error=''
}) => {

  const handleClose = useCallback(()=>{
    if(!loading){
      setOpen(false);
    }
  }, [setOpen,loading]);

  const handleCancel = useCallback(()=>{
    onCancel?.();
  }, [onCancel]);

  const newTitle = success ? 
  <TextInfoSuccessStyled>
    <TitleSuccessStyled>¡Publicación guardada con éxito!</TitleSuccessStyled>
    <p>
      Estamos validando tu participación, vuelve en unos momentos para ver los resultados. :D
    </p>
  </TextInfoSuccessStyled>: 
  '¿Es esta la publicación con la que deseas participar?';

  return (
    <ModalWrapper
      open={open}
      title={newTitle}
      handleClose={handleClose}
    >
      <ContentBodyStyled>
        <SocialMediaCard
          url={url} 
          socialMediaName={socialMediaName} 
        />
        <ContentButtonsStyled>
          {success ? 
          <CustomButton 
            onClick={onContinue}
            disabled={loading}
            style={{ fontSize: '16px', fontWeight: 700 }}
          >
          Continuar
          </CustomButton>
          :
          <>
              {loading ? 
              <CustomButton 
                variant="text" 
                color="default" 
                style={{ outline: 'none', border: 'none',   fontSize: '16px', fontWeight: 700 }}
                loading={true}
              >
              Guardando publicación
              </CustomButton>:
              <>
                <CustomButton 
                  onClick={onConfirm}
                  disabled={loading}
                  data-testid="button-confirm-username"
                  style={{ 
                    width: '100%',
                    flex:1,
                    whiteSpace: 'wrap',
                    fontSize: '16px', 
                    fontWeight: 700 
                  }}
                >
                Sí, participar con esta publicación
                </CustomButton>
                <CustomButton 
                  data-testid="button-cancel-confirm"
                  variant="text" 
                  color="white" 
                  onClick={handleCancel}
                  style={{
                    whiteSpace: 'wrap', 
                    outline: 'none', 
                    border: 'none', 
                    boxShadow: 'none', 
                    fontSize: '16px', 
                    fontWeight: 700 
                  }}
                  disabled={loading}
                >
                No, volver a buscar
                </CustomButton>
              </>}
          </>}
        </ContentButtonsStyled>
        {error && <TextNoteWithProcess type='url' process={'CUSTOM_ERROR'} loading={loading} customError={error} />}
      </ContentBodyStyled>
    </ModalWrapper>
  )
}

export default ModalConfirmUsername;